// extracted by mini-css-extract-plugin
module.exports = {"heading":"Signup_heading__2i_Lm","signup_form":"Signup_signup_form__2DO0O","signup_form_field":"Signup_signup_form_field__2b2zA","paragraph":"Signup_paragraph__28ivW"};